import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function LocationSection() {
  return <section id="ubicacion" className="w-full py-24 relative overflow-hidden" data-id="element-144">
      {/* Marble Background */}
      <div className="absolute inset-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rL7dK7UH3wwQa67MzLqofL/textura-de-marmol-blanco-y-dorado-natural-para-tapiceria-tela-piel-fondo-lujo-interiores-paredes-arte-ceramica-piedra-creativa-268157195.webp)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-145"></div>
      <div className="absolute inset-0 vignette-overlay pointer-events-none" data-id="element-146"></div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10" data-id="element-147">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center" data-id="element-148">
          {/* Left Column: Brand Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-5/12 flex flex-col items-center lg:items-start text-center lg:text-left rounded-2xl p-8 md:p-10" style={{
          background: 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(16px) saturate(180%)',
          WebkitBackdropFilter: 'blur(16px) saturate(180%)',
          border: '1px solid rgba(212, 175, 55, 0.2)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.04)'
        }} data-id="element-149">
            <h2 className="font-serif text-5xl md:text-6xl text-[#2C1810] mb-4" data-id="element-150">
              Iara Oliver
            </h2>
            <p className="font-serif text-lg tracking-[0.2em] text-[#C9956A] uppercase mb-8" data-id="element-151">
              Diseño consciente · Micropigmentación · Rosario
            </p>

            <div className="w-16 h-[1px] bg-[#D4AF37] mb-8" data-id="element-152"></div>

            <p className="text-[#5C3D2E] font-light leading-relaxed mb-10 max-w-md" data-id="element-153">
              Un espacio diseñado para tu bienestar. Disfrutá de una experiencia
              estética consciente en un ambiente cálido, profesional y relajante
              en el corazón de Rosario.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full text-center lg:text-left" data-id="element-154">
              <div className="flex flex-col items-center lg:items-start" data-id="element-155">
                <h4 className="font-medium text-[#2C1810] mb-1" data-id="element-156">Dirección</h4>
                <p className="text-[#7A5C4F] font-light" data-id="element-157">
                  3 de Febrero 2772, Rosario, Santa Fe
                </p>
              </div>

              <div className="flex flex-col items-center lg:items-start" data-id="element-158">
                <h4 className="font-medium text-[#2C1810] mb-1" data-id="element-159">Horarios</h4>
                <p className="text-[#7A5C4F] font-light" data-id="element-160">
                  Lun a Vie: 9:30–12:00 | 13:00–19:00
                </p>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Map */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full lg:w-7/12" data-id="element-161">
            <div className="bg-white p-4 rounded-[28px] shadow-[0_8px_30px_rgba(0,0,0,0.08)] border border-gray-100" data-id="element-162">
              <div className="rounded-[20px] overflow-hidden" data-id="element-163">
                <iframe src="https://maps.google.com/maps?q=3+de+Febrero+2772,+Rosario,+Santa+Fe,+Argentina&output=embed&z=16" width="100%" height="350" style={{
                border: 0
              }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación Iara Oliver Estética - Rosario" className="w-full" data-id="element-164"></iframe>
              </div>
              <div className="mt-6 text-center" data-id="element-165">
                <a href="https://maps.app.goo.gl/6vWfM27oDohMFm117" target="_blank" rel="noopener noreferrer" className="animate-breathe inline-flex items-center justify-center px-8 py-3 rounded-full bg-[#C9956A] text-white font-medium tracking-wide transition-all hover:bg-[#B8865A] hover:shadow-lg" data-id="element-166">
                  📍 Ver en Google Maps
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}